import { render, staticRenderFns } from "./WrongUrl.vue?vue&type=template&id=aee3ce1c&scoped=true"
import script from "./WrongUrl.vue?vue&type=script&lang=js"
export * from "./WrongUrl.vue?vue&type=script&lang=js"
import style0 from "./WrongUrl.vue?vue&type=style&index=0&id=aee3ce1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee3ce1c",
  null
  
)

export default component.exports